import React from "react";

const STATUS_STYLES = {
  good: "bg-emerald-100 text-emerald-700",
  attention: "bg-amber-100 text-amber-700",
  critical: "bg-rose-100 text-rose-700",
};

const BAR_STYLES = {
  good: "bg-emerald-500",
  attention: "bg-amber-500",
  critical: "bg-rose-500",
};

export default function MetricsCard({ metric, onClick }) {
  const statusClass = STATUS_STYLES[metric.status] || STATUS_STYLES.attention;
  const barClass = BAR_STYLES[metric.status] || BAR_STYLES.attention;

  return (
    <button
      type="button"
      className="card card-hover w-full p-4 text-left transition focus-visible:ring-2 focus-visible:ring-amber-400/70 focus-visible:ring-offset-2 focus-visible:ring-offset-white"
      onClick={() => onClick(metric)}
      title={`${metric.label} metric`}
    >
      <div className="flex items-start justify-between gap-2">
        <div>
          <p className="text-sm text-slate-500">{metric.label}</p>
          <p className="mt-2 text-2xl font-semibold text-slate-900">
            {metric.value}
          </p>
        </div>
        <span
          className={`rounded-full px-2 py-1 text-[10px] font-semibold uppercase ${statusClass}`}
        >
          {metric.status}
        </span>
      </div>
      <div className="mt-4">
        <div className="flex items-center justify-between text-xs text-slate-500">
          <span>{metric.kpiLabel}</span>
          <span>{metric.kpiValue}%</span>
        </div>
        <div className="mt-2 h-2 rounded-full bg-slate-100">
          <div
            className={`h-2 rounded-full ${barClass}`}
            style={{ width: `${metric.kpiValue}%` }}
          />
        </div>
      </div>
    </button>
  );
}
